
export const environment = {
  production: false,
  apiURL: 'https://back.devarea.app/mBase/'
};
